import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static values = { autoOpen: Boolean };
  static outlets = ['panel-editor'];

  connect() {
    this._open = this._open.bind(this);
    document.addEventListener('promote:open-learner-response', this._open);

    if (this.autoOpenValue) {
      this._loadAndOpen();
    }
  }

  disconnect() {
    document.removeEventListener('promote:open-learner-response', this._open);
  }

  close(event) {
    if (event) event.preventDefault();

    this.panelEditorOutlet.closePanel();
  }

  _open() {
    this.panelEditorOutlet.openPanel(this.close.bind(this));
  }

  _loadAndOpen() {
    Rails.ajax({
      url: window.location.pathname + window.location.search,
      type: 'GET',
      dataType: 'script'
    });
  }
}
